import React, {useContext, useEffect, useState} from "react"
import {renderForm} from "@components/Form/renderForm"
import {Box, Button, Stack} from "@mui/material"
import {
    deleteAllGames,
    getUsersBenefitsHeaders,
} from "../../api/games";
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {DataGrid} from "@mui/x-data-grid";
import {renderCellExpand} from "@components/renderCellExpand";
import Typography from "@mui/material/Typography";
import Pagination from '@mui/material/Pagination';
import Grid from "@mui/material/Grid/Grid";
import {useConfirm} from "material-ui-confirm";
import {RoleContext} from "../../hoc/role";
import {SUPER_ADMIN} from "../../constants";
import {PrizeManually} from "./PrizeManually";

export const Users = () => {
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);
    const {role} = useContext(RoleContext);
    const confirm = useConfirm();

    const onCallback = (e) => {
        columns.forEach((column) => {
            if (column.name === e.target.name) {
                column.value = e.target.value;
                column.error = '';
            }
        })
        setFormValues([...columns]);

        const shopperId = columns.find(({name}) => name === 'shopperId')
        if(shopperId) setShopperId(shopperId.value)
    }

    const columnsUser = [
        {field: 'assignmentType', headerName: 'assignmentType', renderCell: renderCellExpand},
        {field: 'gameId', headerName: 'gameId', renderCell: renderCellExpand},
        {field: 'id', headerName: 'id', renderCell: renderCellExpand},
        {field: 'imageUrl', headerName: 'imageUrl', renderCell: renderCellExpand},
        {field: 'barCode', headerName: 'barcode', renderCell: renderCellExpand},
        {field: 'issuedOn', headerName: 'issuedOn', renderCell: renderCellExpand},
        {field: 'name', headerName: 'name', renderCell: renderCellExpand},
        // {field: 'result', headerName: 'result', renderCell: renderCellExpand},
        {field: 'status', headerName: 'status', renderCell: renderCellExpand},
        {field: 'supplier', headerName: 'supplier', renderCell: renderCellExpand},
        {field: 'type', headerName: 'type', renderCell: renderCellExpand},
        {field: 'validity', headerName: 'validity', renderCell: renderCellExpand},
    ]

    const columns = [
        {name: 'shopperId', headerName: 'userId', value: '', error: '', inputProps: {minLength: 2}, type: 'string', onCallback},
    ]
    const [formValuesUser] = useState(columnsUser);
    const [rows, setRows] = useState([]);

    const [formValues, setFormValues] = useState(columns);
    const [userGamesHistory, setUserGamesHistory] = useState([]);
    const [userTotalCommitedGames, setUserTotalCommitedGames] = useState(0);
    const [page, setPage] = useState(0);
    const [headers, setHeaders] = useState({});
    const [shopperId, setShopperId] = useState(0);
    const sizePerPage = 20;

    const handleSubmit = async (e) => {
        e.preventDefault()

        try {
            const objVal = {};
            formValues.forEach((formValue) => {
                objVal[formValue.name] = formValue.value;
            })
            const {shopperId} = objVal;
            setShopperId(shopperId)
            await getBenefitOfUser(shopperId)
        } catch (e) {
            setErrorMessage(e);
        }
    }

    const getBenefitOfUser = async (userId) => {
        try {
            setLoading(true);
            setErrorMessage(null);

            const [body, headers] = await getUsersBenefitsHeaders(userId, sizePerPage, page);
            setUserGamesHistory(body);
            setUserTotalCommitedGames(headers.total);
            headers.page *= 1;
            headers.pages *= 1;
            setHeaders(headers);
        } catch (e) {
            setErrorMessage(e);
        }
        setLoading(false);
    }

    const onChangePage = async (e, value) => {
        try {
            e.preventDefault();
            setLoading(true);
            setErrorMessage(null);

            setPage(value);

            const [body, headers] = await getUsersBenefitsHeaders(shopperId, sizePerPage, value - 1);
            setUserGamesHistory(body);
            headers.page *= 1;
            headers.pages *= 1;
            setHeaders(headers);
        } catch (e) {
            setErrorMessage(e);
        }
        setLoading(false);
    }

    const deleteAllGamesFunc = async(e) => {
        try {
            e.preventDefault();
            setLoading(true);
            setErrorMessage(null);

            await confirm({
                title: '',
                description: 'You are clearing all games and prizes in the system! \n Note! played barcodes are still ISSUED. They will not be played anymore. Clear barcodes or call to support. ' })

            await deleteAllGames();
        } catch (e) {
            setErrorMessage(e);
        }
        setLoading(false);
    }

    const  isSuperAdmin = () => {
        return role === SUPER_ADMIN
    }

    useEffect(() => {
        const loadUsers = async () => {
            setLoading(true)
            try {
                if (userGamesHistory) {
                    userGamesHistory.map(e => e.type === "COUPON" && e.result === "WIN" ? e.barCode = e.barCode.code : e.barCode = "")
                    setRows(userGamesHistory);
                }
            } catch (e) {
                setErrorMessage(e)
            }
            setLoading(false)
        }

        loadUsers();
    }, [userGamesHistory, setLoading, setErrorMessage])

    return (
        <>
            <Grid container spacing={1} alignItems="center" justifyContent="center">
                <Grid item xs={12} md={isSuperAdmin() ? 4 : 6}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <Typography component="h4">Write here user Id</Typography>
                        <Box
                            component="form"
                            onSubmit={handleSubmit}
                            sx={{mt: 1, maxWidth: 200}}
                            noValidate
                        >
                            {formValues.map((data, key) => {
                                return renderForm(data, key);
                            })}
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{mt: 3, mb: 2}}
                            >
                                Get User Statistics
                            </Button>

                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={isSuperAdmin() ? 4 : 6}>
                   <PrizeManually shopperId={shopperId} />
                </Grid>
                {isSuperAdmin() ? (<Grid item xs={12} md={4}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <Button
                            color="error"
                            onClick={(e) => deleteAllGamesFunc(e)}
                            variant="contained"
                            sx={{mt: 3, mb: 2}}
                        >
                            Delete all games
                        </Button>
                    </Box>
                </Grid>) : ''}
            </Grid>
            {userTotalCommitedGames ? <Box><Typography fontSize={22}
                                                       component={'h3'}>Total {userTotalCommitedGames}</Typography></Box> : ""}
            {rows.length ? <Box
                style={{height: 400, width: '100%'}}>
                <DataGrid
                    hideFooterPagination={true}
                    pageSize={sizePerPage}
                    autoHeight={true}
                    rows={rows}
                    columns={formValuesUser}
                    rowsPerPageOptions={[]}
                />
                <Stack spacing={2}>
                    {
                        headers?.pages && headers?.page ? (<>
                            <Typography>Page: {headers.page}</Typography>
                            <Pagination count={headers.pages} page={headers.page - 1} onChange={onChangePage}/>
                        </>) : ''
                    }
                </Stack>
            </Box> : ""}
        </>
    )
} 